import { ComposerPrimitive, MessagePrimitive, useAuiState } from '@assistant-ui/react';
import { Button } from '@mantine/core';
import { IconPencilCheck, IconX } from '@tabler/icons-react';

import { BranchPicker } from './BranchPicker.tsx';
import classes from './Thread.module.css';
import { UserActionBar } from './UserActionBar.tsx';
import { Bubble } from '#plugin-chat/components/bubble/Bubble.tsx';
import { StreamingMarkdown } from '#plugin-chat/components/markdown-text/StreamingMarkdown.tsx';

/**
 * Renders a user message in the chat thread with edit/branch navigation controls.
 */
export function UserMessage() {
  const isEditing = useAuiState(({ composer }) => composer.isEditing);
  return (
    <MessagePrimitive.Root className={classes.messageContainer} data-role="user">
      <div className={classes.contentWrapper}>
        <Bubble role="user">
          {isEditing ? (
            <ComposerPrimitive.Root>
              <div className={classes.editForm}>
                <ComposerPrimitive.Input autoFocus className={classes.editComposer} maxRows={10} rows={3} />
                <div className={classes.editActions}>
                  <ComposerPrimitive.Cancel asChild>
                    <Button leftSection={<IconX size={14} />} size="xs" variant="transparent">
                      Cancel
                    </Button>
                  </ComposerPrimitive.Cancel>
                  <ComposerPrimitive.Send asChild>
                    <Button leftSection={<IconPencilCheck size={14} />} size="xs" variant="white">
                      Update
                    </Button>
                  </ComposerPrimitive.Send>
                </div>
              </div>
            </ComposerPrimitive.Root>
          ) : (
            <MessagePrimitive.Parts
              components={{
                // Override Text renderer to enable markdown formatting in user input
                Text: StreamingMarkdown,
              }}
            />
          )}
        </Bubble>
        {!isEditing && (
          <>
            <div className={classes.userActionBar}>
              <UserActionBar />
            </div>

            <BranchPicker className={classes.branchPicker} />
          </>
        )}
      </div>
    </MessagePrimitive.Root>
  );
}
